import React, { useState, useEffect, useContext } from "react"
import {
  Breadcrumb,
  BreadcrumbItem,
} from "react-bootstrap"
import "./MigasDePan.css"
import UAI from "../UAI"
import { UsuarioContext } from "../Context/Usuario"
import ReactGA from "react-ga"
import log from "loglevel"

const MigasDePan = (props) => {
  const { usuario } = useContext(UsuarioContext)

  const [vista, setVista] = useState(null)

  useEffect(() => {
    if (!props.view) {
      throw new Error("Vista inválida para migas de pan")
    }
    if (props.external) {
      let _original = UAI.vistas[props.view.key]
      if (!_original) {
        log.error(
          "Vista externa sin registro en vista original! Key:" + props.view.key
        )
      }
      setVista(_original)
    } else {
      setVista(props.view)
    }
  }, [props, usuario])

  if (vista === null || vista === undefined) {
    return ""
  }

  ReactGA.pageview(window.location.pathname + window.location.search)

  return (
    <>
      <Breadcrumb className="reload-container migas-cohortes">
        <BreadcrumbItem className="miga-activa">
          {usuario.periodo}
        </BreadcrumbItem>
        {vista.category && <BreadcrumbItem>{vista.category}</BreadcrumbItem>}
        {vista.subcategory && (
          <BreadcrumbItem>{vista.subcategory}</BreadcrumbItem>
        )}
        <BreadcrumbItem>{vista.title}</BreadcrumbItem>
      </Breadcrumb>
    </>
  )
}

export default MigasDePan
